// extracted by mini-css-extract-plugin
export var container = "DocumentPopover-module--container--IZq0u";
export var content = "DocumentPopover-module--content--kcqGK";
export var popover = "DocumentPopover-module--popover--C5+aU";
export var popoverFadeIn = "DocumentPopover-module--popoverFadeIn--UhymQ";
export var trigger = "DocumentPopover-module--trigger--5xZmr";